<template>
  <section>
    <div v-if="quotes">
      <expiry-date></expiry-date>
      <proposals-master-detail></proposals-master-detail>
      <p
        class="subtext-proposals font-weight-bold d-none d-md-block"
        v-if="multipleQuotes"
        v-dynamic-content:pv_cta_choose_text
      ></p>
    </div>
    <div v-else>
      <loader :fullscreen="true"></loader>
    </div>
    <ContentLow />
  </section>
</template>

<script>
import ExpiryDate from '@/components/parts/ExpiryDate'
import ContentLow from '../parts/ContentLow'
import ProposalsMasterDetail from './ProposalsMasterDetail'

export default {
  mixins: [],
  name: 'ContentProposal',
  components: {
    ContentLow,
    ProposalsMasterDetail,
    ExpiryDate,
  },
  mounted() {
    this.$store.commit('SET_SCROLL_POSITION', 0)

    this.$store.commit('RESET_SERVICE_PRODUCTS_SERVICES')

    // open first quote, if there is only 1
    if (this.quotes && !this.multipleQuotes && this.$route.name !== 'card-detail') {
      this.$router.push({
        name: 'card-detail',
        params: { id: this.quotes[0].id },
      })
    }

    window.dataLayer.push({
      event: 'page_load',
      element: 'system overview',
      quote_type: this.$store.getters.quoteType,
      number_of_quotes: this.quotes && this.quotes.length 
    })
  },
}
</script>
